export default __webpack_public_path__ + "static/char-s-06-jp-2faa2692f6cd20dd580f8a4593e0f252.webp";